import MUserInvitationItem from './index.vue';

MUserInvitationItem.install = app => {
  app.component(MUserInvitationItem.name, MUserInvitationItem);
};

export default MUserInvitationItem;
